import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionMainTarget } from "./main-target";
import { QuestionPlanName } from "./name";

import type { PlanI18nCategoriesAndManagerStore } from "../../store/categories";

type Props = {
	base: PlanI18nCategoriesAndManagerStore["base"];
};

export const QuestionPlanBase = ({ base }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={base}>
			<QuestionPlanName />
			<QuestionMainTarget />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionPlanBase.displayName = "QuestionPlanBase";
